<span class=" row justify-content-center confirmation-message">
    {{data.message}}
</span>